import React from 'react'

import { Table, Button, Tooltip } from 'antd'
import { EditOutlined, SolutionOutlined } from '@ant-design/icons'

import {
  baseUnitRender,
  categoryRender,
  deadlineAtRender,
  languageTypeRender,
  statusRender
} from '../../../../components/table/fields/task'

const ButtonGroup = Button.Group

const rowKey = (row) => row.id.toString()

const Widget = (props) => {
  const columns = [
    {
      title: 'ID #',
      dataIndex: 'job',
      render: (job, record) => {
        return (
          <ButtonGroup>
            <Tooltip title='View'>
              <Button
                size='small'
                onClick={() => props.quickView(record.job.id)}
                icon={<SolutionOutlined />}
              />
            </Tooltip>
            <Button
              onClick={() => props.viewMore(record.job.id)}
              size='small'
              style={{ color: '#40a9ff', orderColor: '#40a9ff' }}
              icon={<EditOutlined />}
            >
              {job.display_id}
            </Button>
          </ButtonGroup>
        )
      }
    },
    {
      title: 'E-ID #',
      dataIndex: 'job',
      render: (job, record) => <>{job?.eid}</>
    },
    {
      title: 'Task #',
      dataIndex: 'code',
      key: 'name',
      render: (job, record) => (
        <>
          {record.name} / {record.code}
        </>
      )
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 140,
      render: statusRender
    },
    { title: 'Service', dataIndex: 'name', key: 'name' },
    { title: 'Category', dataIndex: 'category', key: 'category', render: categoryRender },
    {
      title: 'Language(s)',
      dataIndex: 'language_type',
      key: 'languageType',
      render: languageTypeRender
    },

    {
      title: 'Unit',
      dataIndex: 'base_unit',
      key: 'unit',
      render: baseUnitRender
    },
    {
      title: 'Deadline',
      dataIndex: 'deadline_at',
      key: 'deadlineAt',
      render: deadlineAtRender
    }
  ]

  return (
    <>
      <Table columns={columns} dataSource={props.list} size='small' pagination={false} rowKey={rowKey} />
    </>
  )
}

export default Widget
